<script setup lang="ts">
import { computed, defineProps } from "vue";

import Icon from "@components/Icon.vue";
import Button from "@components/Button.vue";
import { numberToHumanDuration } from "@modules/helpers";

const props = defineProps<{
  creatorName: string;
  recordingTime: number;
  href: string;
}>();

const humanRecordingTime = computed(() => {
  const duration = props.recordingTime;
  if (!duration) return null;
  if (duration > 15 * 60) return null;

  return numberToHumanDuration(duration).toLowerCase();
});
</script>

<template>
  <div
    class="flex select-none flex-col items-center justify-center gap-4 bg-[#1f4dc1] !bg-colorful-backdrop p-10 py-16 text-center text-xl font-bold screen:shadow-lg"
  >
    <div class="">
      <Icon icon="sparkles" class="h-20 text-white/80" />
    </div>

    <h2
      class="bg-gradient-to-b from-white/100 to-white/50 bg-clip-text text-2xl font-bold tracking-tight text-transparent sm:text-3xl"
    >
      <div>
        <template v-if="humanRecordingTime">
          Created by {{ creatorName }} in {{ humanRecordingTime || "a few minutes" }}.<br />
          An AI did all of the editing.
        </template>
        <template v-else>
          {{ creatorName }} recorded this video.<br />
          An AI did all of the editing.</template
        >
      </div>
    </h2>

    <div class="group flex items-center justify-center gap-2.5 text-sm font-normal text-white/80">
      <div class="">made with</div>
      <a
        :href="`https://recordonce.com/?ref=share/{video.token}`"
        target="_blank"
        class="-m-1.5 flex items-center justify-center gap-1.5 rounded-lg p-1.5 pr-3 text-inherit transition-all hover:bg-white/10"
      >
        <img src="@assets/images/Record-Once-icon-64x64px.svg" class="block h-6 w-6" />
        <div class="font-bold tracking-tight">Record Once</div>
      </a>
    </div>

    <div class="mt-3">
      <Button
        as="a"
        :href="href"
        target="_blank"
        :transparency="true"
        class="!cursor-pointer !border-white/[15%] !px-6 !py-4 text-sm transition-transform ease-in-out hover:scale-105"
        label="Show me how"
      />
    </div>
  </div>
</template>
